import React, { FC } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { globalTheme } from '@cld/component-theme';
import { website } from '@cld/typography';
import { messages } from '../../../../i18n';

const Root = styled.div`
  width: calc(${globalTheme.spacing.lg} * 19);
  margin-left: calc(${globalTheme.spacing.lg} * 10);
`;

const Heading = styled.h2`
  ${website.headlines.xl.bold};
`;

const Contents = styled.p`
  ${website.brandText.lg.regular};
`;

export const Text: FC = () => (
  <Root>
    <Heading>
      <FormattedMessage {...messages['landing.embedSection.heading']} />
    </Heading>
    <Contents>
      <FormattedMessage {...messages['landing.embedSection.text']} />
    </Contents>
  </Root>
);
